// Open positions shown on /karriere. To publish a new vacancy, add an
// object here; to close one, remove it.
const jobsData = [
    {
        id: 'zfa-prophylaxeassistenz',
        title: 'ZFA / Prophylaxeassistentin (m/w/d)',
        datePosted: '2026-10-16',
        employmentType: ['PART_TIME', 'OTHER'],
        facts: [
            { label: 'Umfang', value: 'Teilzeit oder Minijob' },
            { label: 'Beginn', value: 'ab sofort' },
            { label: 'Ort', value: 'Kornstraße 53a, Tönisvorst' },
        ],
        intro: [
            'Du suchst ein herzliches Team, faire Bedingungen und eine Praxis, in der du dich wirklich wohlfühlst? Dann komm zu uns!',
            'Wir suchen ab sofort eine motivierte ZFA oder Prophylaxeassistentin (m/w/d) zur Verstärkung unserer Zahnarztpraxis – in Teilzeit oder als Nebenjob ab sofort.',
        ],
        benefits: [
            { title: 'Ein familiäres Team', text: 'Wir unterstützen uns gegenseitig und lachen gerne zusammen.' },
            { title: 'Erholung pur', text: 'Bis zu 40 Urlaubstage.' },
            { title: 'Faire Bezahlung', text: 'Deine gute Arbeit wird bei uns auch gut und fair entlohnt.' },
            { title: 'Mobilitäts-Bonus', text: 'Wir zahlen dir einen Zuschuss zu deinen Fahrtkosten.' },
            { title: 'Flexibilität', text: 'Die Stelle ist in Teilzeit oder als Nebenjob (Minijob) möglich.' },
            { title: 'Perspektive & Spaß', text: 'Regelmäßige Fortbildungen und coole Teamevents.' },
        ],
        requirements: [
            'Eine abgeschlossene Ausbildung als Zahnmedizinische Fachangestellte (ZFA) (m/w/d).',
            'Idealerweise Erfahrung in der Prophylaxe (kein Muss, wir lernen dich auch gerne an!).',
            'Freude am Umgang mit Patienten und Teamgeist.',
        ],
    },
];

export const JOBS_EMAIL = 'jobs@zahnarzt-st-toenis.de';

export default jobsData;
